<div class="alert alert-warning notif_info w-100" role="alert">
  <div class="d-flex center">
    <div class="icons">
      <i class="fa fa-info-circle icon"></i>
    </div>
    <span class="alert-heading title">
      {{ warningMessage | translate }}
    </span>
  </div>
</div>
